import { render } from "./Star.vue?vue&type=template&id=7f2350ae&scoped=true"
import script from "./Star.vue?vue&type=script&lang=js"
export * from "./Star.vue?vue&type=script&lang=js"

import "./Star.vue?vue&type=style&index=0&id=7f2350ae&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7f2350ae"

export default script